<template>
  <b-form @submit.prevent="onSubmit">
    <edit-user-form />

    <div class="text-right">
      <b-button :disabled="busy" class="mb-2" pill type="submit" variant="primary"
        >Update
        <div v-if="busy" style="display: inline;">
          <b-spinner small></b-spinner>
          <span class="sr-only">Loading...</span>
        </div>
      </b-button>
    </div>
  </b-form>
</template>
<script>
  import { mapState } from 'vuex';
  import EditUserForm from './EditUserForm';

  export default {
    name: 'EditUser',
    components: { EditUserForm },
    data() {
      return {
        busy: false,
      };
    },
    computed: {
      ...mapState({
        userForm: state => state.salesforceUserForm.userForm,
      }),
    },
    methods: {
      goToAdminPanel() {
        this.$router.push({ name: 'salesforce-admin-panel' });
      },
      async onSubmit() {
        this.busy = true;
        let payload = {
          email: this.userForm.email,
          simRole: this.userForm.simRole,
          simPermission: this.userForm.simPermission,
        };
        await axios
          .patch(`/api/salesforce/users/${this.userForm.ID}`, payload)
          .then(results => {
            this.$emit('userUpdated', results.data);
          })
          .catch(err => {
            console.log(err);
            this.$bvToast.toast(`Could Not Edit User - ${err.response.data.errorMessage}`, {
              title: 'Error',
              autoHideDelay: 5000,
              appendToast: true,
              variant: 'danger',
            });
            this.errors = err.response.data.errors;
          });
        this.busy = false;
      },
    },
  };
</script>
